import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the document to the top on SPA navigations.
 * On the home route with a hash (e.g. /#pricing),
 * skips so LandingPage can scroll that section into view.
 */
function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (pathname === '/' && hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, search]);

  return null;
}

export default ScrollToTop;
